import { DocScripts } from "../components/widgets/codeBlock";

export const cfdiScripts = {
    minimo: {
        requests: [{
            language: 'JSON',
            subtitle: 'Cuerpo del request',
            subsubtitle: '(application/json)',
            code: `
{
    "formaPago": "01",
    "metodoPago": "PUE",
    "lugarExpedicion": "06700",
    "receptor": {
        "nombre": "PUBLICO EN GENERAL",
        "rfc": "XAXX010101000",
        "usoCFDI": "S01",
        "regimen": "616",
        "zip": "06700",
    },
    "conceptos": [
        {
            "claveProdServ": "10101500",
            "claveUnidad": "KGM",
            "cantidad": 1,
            "descripcion": "PROYECTO ILUMINACION MASCAREÑO",
            "valorUnitario": 2000,
            "impuestos": [
                {
                    "type": "iva",
                    "retencion": false,
                    "tasa": 0.16
                }
            ]
        }
    ]
}
`
        }],
        response: {
            language: 'JSON',
            subtitle: 'Respuesta correcta',
            code: `
{
    "uuid": "3407BE43-651B-45B2-A721-D41295ED587B",
    "created": "2018-09-07T17:54:26.150Z",
    "json": {
        "@": {
            "xmlns:cfdi" : "http://www.sat.gob.mx/cfd/4",
			"xmlns:xsi" : "http://www.w3.org/2001/XMLSchema-instance",
			"xsi:schemaLocation" : "http://www.sat.gob.mx/cfd/4 http://www.sat.gob.mx/sitio_internet/cfd/4/cfdv40.xsd",
			"Version" : "4.0",
            "Serie": "A",
            "Folio": "01",
            "Fecha": "2018-09-07T12:54:25",
            "TipoDeComprobante": "I",
            "FormaPago": "01",
            "MetodoPago": "PUE",
            "LugarExpedicion": "06700",
            "SubTotal": "2000.00",
            "Total": "2320.00",
            "Moneda": "MXN",
            "Sello": "Eh49rUg0RiMsNmuiNwGay3oxWt9+Y16s+Ui9bq5+jzSicfkxPfUdCumYsAOndQRfUUK+cuWn1gCWBa/guFY1hwJYvFg/5X4gAZ...",
            "Certificado": "MIIF6zCCA9OgAwIBAgIUMjAwMDEwMDAwMDAzMDAwMDU2OTIwDQYJKoZIhvcNAQELBQAwggFmMSAwHgYDVQQDDBdBLkMu...",
            "NoCertificado": "20001000000300005692",
            "Exportacion" : "01"                        // CFDI 4.0
        },
        "cfdi:Emisor": {
            "@": {
                "Nombre": "INNOVACION Y DESARROLLO",
                "Rfc": "ACO560518KW7",
                "RegimenFiscal": "601"
            }
        },
        "cfdi:Receptor": {
            "@": {
                "Nombre": "PUBLICO EN GENERAL",
                "Rfc": "XAXX010101000",
                "UsoCFDI": "S01",
                "DomicilioFiscalReceptor" : "06700",    // CFDI 4.0
				"RegimenFiscalReceptor" : "616"         // CFDI 4.0
            }
        },
        "cfdi:Conceptos": {
            "cfdi:Concepto": [
                {
                    "@": {
                        "ClaveProdServ": "10101500",
                        "ClaveUnidad": "KGM",
                        "Cantidad": "1",
                        "Descripcion": "PROYECTO ILUMINACION MASCAREÑO",
                        "ValorUnitario": "2000.00",
                        "Importe": "2000.00",
                        "ObjetoImp" : "02"              // CFDI 4.0
                    },
                    "cfdi:Impuestos": {
                        "cfdi:Traslados": {
                            "cfdi:Traslado": [
                                {
                                    "@": {
                                        "Base": "2000.00",
                                        "Impuesto": "002",
                                        "TipoFactor": "Tasa",
                                        "TasaOCuota": "0.160000",
                                        "Importe": "320.00"
                                    }
                                }
                            ]
                        }
                    }
                }
            ]
        },
        "cfdi:Impuestos": {
            "@": {
                "TotalImpuestosTrasladados": "320.00"
            },
            "cfdi:Traslados": {
                "cfdi:Traslado": [
                    {
                        "@": {
                            "Impuesto": "002",
                            "TipoFactor": "Tasa",
                            "TasaOCuota": "0.160000",
                            "Importe": "320.00"
                        }
                    }
                ]
            }
        }
    },
    "xml": ".....",
    "authToken": "...",
    "status": true,
    "sandbox": false
}`
        }
    } as DocScripts,
    maximo: {
        requests: [{
            language: 'JSON',
            subtitle: 'Cuerpo del request',
            subsubtitle: '(application/json)',
            code: `
{
    "fecha": "2020-08-29T00:41:03.041Z", // Fecha de la factura en formato JSON (new Date().toJSON() en JS)
    "formaPago": "01",
    "metodoPago": "PUE",
    "tipoDeComprobante": "I", // 'I' | 'E' | 'P' | 'N' | 'T'
    "lugarExpedicion": "06700",
    "serie": "A", // Serie de la factura
    "folio": "01", // Folio de la factura
    "moneda": "USD", 
    "tipoCambio": "22.1", 
    "condicionesDePago": "En contra entrega", 
    "note": "Alguna nota", // Mensaje en el pié del PDF
    "receptor": {
        "nombre": "PUBLICO EN GENERAL",
        "rfc": "XAXX010101000",
        "usoCFDI": "S01",
        "regimen": "616",
        "zip": "06700",
        "email": "jorge@example.com", // Agregar correo, envia el PDF y XML al cliente
    },
    "conceptos": [
        {
            "claveProdServ": "10101500",
            "claveUnidad": "KGM",
            "cantidad": 1,
            "descripcion": "PROYECTO ILUMINACION MASCAREÑO",
            "valorUnitario": 2000,
            "descuento": 120, // Descuento es sin impuestos (antes de impuestos)
            "noIdentificacion": "SKU-01-569",
            "impuestos": [
                {
                    "type": "iva",
                    "retencion": false,
                    "tasa": 0.16
                }
            ]
        }
    ],
    "cfdiRelacionados": {
        "tipoRelacion": "01", //  '01' | '02' | '03' | '04' | '05' | '06' | '07' | '08' | '09';
        "uuids": ["2407BE43-651B-45B2-A721-B32295ED779C", "2407BE43-651B-45B2-A721-B32295A1210E"]
    }
}
`
        }],
        response: {
            language: 'JSON',
            subtitle: 'Respuesta correcta',
            code: `
{
    "uuid": "3407BE43-651B-45B2-A721-D41295ED587B",
    "created": "2018-09-07T17:54:26.150Z",
    "json": {
        "@": {
            "xmlns:cfdi": "http://www.sat.gob.mx/cfd/3",
            "xmlns:xsi": "http://www.w3.org/2001/XMLSchema-instance",
            "xsi:schemaLocation": "http://www.sat.gob.mx/cfd/3 http://www.sat.gob.mx/sitio_internet/cfd/3/cfdv33.xsd",
            "Version": "3.3",
            "Serie": "A",
            "Folio": "01",
            "Fecha": "2018-09-07T12:54:25",
            "TipoDeComprobante": "I",
            "FormaPago": "01",
            "MetodoPago": "PUE",
            "LugarExpedicion": "06700",
            "SubTotal": "2000.00",
            "Total": "2320.00",
            "Moneda": "MXN",
            "Sello": "Eh49rUg0RiMsNmuiNwGay3oxWt9+Y16s+Ui9bq5+jzSicfkxPfUdCumYsAOndQRfUUK+cuWn1gCWBa/guFY1hwJYvFg/5X4gAZ...",
            "Certificado": "MIIF6zCCA9OgAwIBAgIUMjAwMDEwMDAwMDAzMDAwMDU2OTIwDQYJKoZIhvcNAQELBQAwggFmMSAwHgYDVQQDDBdBLkMu...",
            "NoCertificado": "20001000000300005692",
            "Exportacion" : "01"                        // CFDI 4.0
        },
        "cfdi:Emisor": {
            "@": {
                "Nombre": "Horacio Llanos",
                "Rfc": "ACO560518KW7",
                "RegimenFiscal": "601"
            }
        },
        "cfdi:Receptor": {
            "@": {
                "Nombre": "PUBLICO EN GENERAL",
                "Rfc": "XAXX010101000",
                "UsoCFDI": "S01",
                "DomicilioFiscalReceptor" : "06700",    // CFDI 4.0
				"RegimenFiscalReceptor" : "616"         // CFDI 4.0
            }
        },
        "cfdi:Conceptos": {
            "cfdi:Concepto": [
                {
                    "@": {
                        "ClaveProdServ": "10101500",
                        "ClaveUnidad": "KGM",
                        "Cantidad": "1",
                        "Descripcion": "PROYECTO ILUMINACION MASCAREÑO",
                        "ValorUnitario": "2000.00",
                        "Importe": "2000.00",
                        "ObjetoImp" : "02"              // CFDI 4.0
                    },
                    "cfdi:Impuestos": {
                        "cfdi:Traslados": {
                            "cfdi:Traslado": [
                                {
                                    "@": {
                                        "Base": "2000.00",
                                        "Impuesto": "002",
                                        "TipoFactor": "Tasa",
                                        "TasaOCuota": "0.160000",
                                        "Importe": "320.00"
                                    }
                                }
                            ]
                        }
                    }
                }
            ]
        },
        "cfdi:Impuestos": {
            "@": {
                "TotalImpuestosTrasladados": "320.00"
            },
            "cfdi:Traslados": {
                "cfdi:Traslado": [
                    {
                        "@": {
                            "Impuesto": "002",
                            "TipoFactor": "Tasa",
                            "TasaOCuota": "0.160000",
                            "Importe": "320.00"
                        }
                    }
                ]
            }
        }
    },
    "xml": ".....",
    "authToken": "...",
    "status": true,
    "sandbox": false
}`
        }
    } as DocScripts,
    cancelar: {
        requests: [{
            language: 'JSON',
            subtitle: 'Cuerpo del request',
            subsubtitle: '(application/json)',
            code: `
{
    "uuids": ["96AF6CF8-7D56-41AD-B63B-80F531A311E5", "..."]
}`
        }],
        response: {
            language: 'JSON',
            subtitle: 'Respuesta correcta',
            code: `
{
    "folios": [
        {
            "estatus": 201,
            "uuid": "3407BE43-651B-45B2-A721-D41295ED587B"
        }
    ],
    "fecha": "2018-09-07T18:34:17.000Z",
    "rfcEmisor": "ACO560518KW7"
}`
        }
    } as DocScripts,
    buscar: {
        requests: [],
        response: {
            language: 'JSON',
            subtitle: 'Respuesta correcta',
            code: `
[
    {
        "created": "2018-09-07T17:54:26.150Z",
        "uuid": "3407BE43-651B-45B2-A721-D41295ED587B",
        "json": {...},
        "xml":"...",
        "authToken": "...",
        "status": false,
        "sandbox": false
    }
]`
        }
    } as DocScripts,
    buscarSingle: {
        requests: [],
        response: {
            language: 'JSON',
            subtitle: 'Respuesta correcta',
            code: `
[
    {
        "created": "2018-09-07T17:54:26.150Z",
        "uuid": "3407BE43-651B-45B2-A721-D41295ED587B",
        "json": {...},
        "xml":"...",
        "authToken": "...",
        "status": false,
        "sandbox": false
    }
]`
        }
    } as DocScripts,
    pago: {
        requests: [{
            language: 'JSON',
            subtitle: 'Cuerpo del request',
            subsubtitle: '(application/json)',
            code: `
{
    "lugarExpedicion": "48290",
    "serie": "FESL",
    "folio": "01-01",
    "receptor": {
        "nombre": "EMPRESA SOCIEDAD LIMITADA",
        "rfc": "EMP880708J21",
        "usoCFDI": "S01",
        "regimen": "601",       // COMPLEMENTO PAGO 2.0
        "zip": "20928"          // COMPLEMENTO PAGO 2.0
    },
    "pagos": [
        {
            "fecha": "2020-09-02T00:52:15.362Z",
            "formaDePago": "03",
            "monto": 1237,
            "facturaRelacionada": [
                {
                    "uuid": "...",
                    "importePagado": 1237,
                    "numParcialidad": 2 
                }
            ]
        }
    ]
}`
        }],
        response: {
            language: 'JSON',
            subtitle: 'Respuesta correcta',
            code: `
[
    {
        "created": "2018-09-07T17:54:26.150Z",
        "uuid": "3407BE43-651B-45B2-A721-D41295ED587B",
        "json": {
            "@": {
                "xmlns:cfdi": "http://www.sat.gob.mx/cfd/4",
                "xmlns:xsi": "http://www.w3.org/2001/XMLSchema-instance",
                "xsi:schemaLocation": "http://www.sat.gob.mx/cfd/4 http://www.sat.gob.mx/sitio_internet/cfd/4/cfdv40.xsd http://www.sat.gob.mx/Pagos20 http://www.sat.gob.mx/sitio_internet/cfd/Pagos/Pagos20.xsd",
                "Version": "4.0",
                "Serie": "PAGO",
                "Folio": "02-21",
                "Fecha": "2022-05-03T23:06:34",
                "TipoDeComprobante": "P",
                "LugarExpedicion": "48290",
                "SubTotal": "0",
                "Total": "0",
                "Moneda": "XXX",
                "Sello": "Of1DjUGZyfyZEnjBsgrcN32pbdSzdaEG94AjmQOHYYdEUvijRZTljMwXE9FpR+k4eunngfv2S2jQcltDxgtKlK9MjKj/5JaLH8clGLGl1rcElPbHMwqGZUVoJcxaSIsghpgI9WkgZ+ZQTUbNtdIuzCrALzu6kjjD9AGpwJ3OdP11mslp3fAmGl5t/WtA0smJVGU+F4UFZT80fbggrxcKbyiSGF5fPzB+daqRy/AhrPbgkfT73RPzPNJvH30biBLnyWJYM0b0g3SoVKy9tDZsWb+0p1M1Nu3yYwcIh5KE/KzkJE7UWCdl5DmPMm2P+TJx+UHE4W157ZxLTp6T6Ls+lQ==",
                "Certificado": "MIIF0jCCA7qgAwIBAgIUMzAwMDEwMDAwMDA0MDAwMDI0MzgwDQYJKoZIhvcNAQELBQAwggErMQ8wDQYDVQQDDAZBQyBVQVQxLjAsBgNVBAoMJVNFUlZJQ0lPIERFIEFETUlOSVNUUkFDSU9OIFRSSUJVVEFSSUExGjAYBgNVBAsMEVNBVC1JRVMgQXV0aG9yaXR5MSgwJgYJKoZIhvcNAQkBFhlvc2Nhci5tYXJ0aW5lekBzYXQuZ29iLm14MR0wGwYDVQQJDBQzcmEgY2VycmFkYSBkZSBjYWRpejEOMAwGA1UEEQwFMDYzNzAxCzAJBgNVBAYTAk1YMRkwFwYDVQQIDBBDSVVEQUQgREUgTUVYSUNPMREwDwYDVQQHDAhDT1lPQUNBTjERMA8GA1UELRMIMi41LjQuNDUxJTAjBgkqhkiG9w0BCQITFnJlc3BvbnNhYmxlOiBBQ0RNQS1TQVQwHhcNMTkwNjE3MjAwNDEyWhcNMjMwNjE3MjAwNDEyWjCB+TEpMCcGA1UEAxMgSU5OT1ZBQ0lPTiBWQUxPUiBZIERFU0FSUk9MTE8gU0ExKTAnBgNVBCkTIElOTk9WQUNJT04gVkFMT1IgWSBERVNBUlJPTExPIFNBMSkwJwYDVQQKEyBJTk5PVkFDSU9OIFZBTE9SIFkgREVTQVJST0xMTyBTQTElMCMGA1UELRMcSVZEOTIwODEwR1UyIC8gS0FITzY0MTEwMUIzOTEeMBwGA1UEBRMVIC8gS0FITzY0MTEwMUhOVExLUzA2MS8wLQYDVQQLFCZJTk5PVkFDSdNOIFZBTE9SIFkgREVTQVJST0xMTyBTQSBERSBDVjCCASIwDQYJKoZIhvcNAQEBBQADggEPADCCAQoCggEBAIKn3U4zMIEGfAICsDCSD4EQwQbabWJOdQpXdnAeCqwIH/vAbnv4t7Rc1NFMJg2OeCK5L6g+Pj/DlWftOeqRo8KIzW04xtq6rWSxXXuhGDm9hdRF15JEoxJnpDmkqKLEpbLJqZ4mOdKOHdmEdQ4O3dd0njeNGdjhU5+Vl4J9rHVjA4BoJpsP75BQeIwDdFIVxcb60sKna0mG58lMq5tNK6CtozeyrC94IED9GARG0gKuXlswTrWrI1N3/VOI7jjZY6YeIeO5jcbXrCiqGxGduJrGHqyrxGPTIXlZ7iW8zMT1G8QRF5rWutg4+MysIsjrcFrexbP5TMaRBYyASeBd94kCAwEAAaMdMBswDAYDVR0TAQH/BAIwADALBgNVHQ8EBAMCBsAwDQYJKoZIhvcNAQELBQADggIBAJVqgdQ+NOSIBKbWBBSARmX5C0wiq0BfRz4Ub7dVGguHoPAB4dJAtL540b3Klid90EwtNSCCFSc9OPQ0mWVRkCz0OtceLKAXzKqzVOcXrxmydlbT0brNBkULDV54Gdup1B42mmCh0hoRaNvr0QkJnKEMTmHt3m47xnV9XfOeUcSDciCTMV4wRns3JdCr7g0PMyWpV5yRLJNr8w9YCm6YesSqCJLZIvWbFGRuDhHfgsyImtMuTNbclbI7XFue2B4awi3a9H8yfgf33bGgeLhVCAbILd63LQv67zGdt3H8s2Xe4umQmh+9gyJG4fmbZmUd3wFl/fY9kmdTxZfufqPbdyV/G7g0Hq3mmzS1TuRG2Hj+y4lVzLOV6RXJjIQ+Qp+5ePKl4d/oeAIsTzmWsZc0c+yJ1MMbCn6CHTlNvdwROOhpanNjEHJ2kLwh5nhoVSRbRF/owuBreO5FbJKZE+L+8mzYEIhKUiD03WW03BOPCCQFFvBFC0AoN7wS0zFm1g2gNV95pgZwp1LsqlwBSAVF9SS/MKiE7Mv0UryWEBYllo66XY8VMFzZYAjSuEudoK3xSsCdjaA/Wjx85/3RCEV3J7LO5m6mwYgrQIaTwuYWuCTUE8XKxj7cjNo1UF6LbL77nzbYmS3sUXE4Jly8xxOYsyDX8B+8TNW++g1mB3bt+OHv",
                "NoCertificado": "30001000000400002438",
                "Exportacion": "01",
                "xmlns:pago20": "http://www.sat.gob.mx/Pagos20"
            },
            "cfdi:Emisor": {
                "@": {
                    "Nombre": "INNOVACION VALOR Y DESARROLLO",
                    "Rfc": "IVD920810GU2",
                    "RegimenFiscal": "601"
                }
            },
            "cfdi:Receptor": {
                "@": {
                    "Nombre": "EMPRESA SOCIEDAD LIMITADA",
                    "Rfc": "EMP880708J21",
                    "UsoCFDI": "CP01",
                    "DomicilioFiscalReceptor": "20928",
                    "RegimenFiscalReceptor": "601"
                }
            },
            "cfdi:Conceptos": {
                "cfdi:Concepto": [
                    {
                        "@": {
                            "ClaveProdServ": "84111506",
                            "ClaveUnidad": "ACT",
                            "Cantidad": "1",
                            "Descripcion": "Pago",
                            "ValorUnitario": "0",
                            "Importe": "0",
                            "ObjetoImp": "01"
                        }
                    }
                ]
            },
            "cfdi:Complemento": {
                "pago20:Pagos": {
                    "@": {
                        "Version": "2.0"
                    },
                    "pago20:Totales": {
                        "@": {
                            "MontoTotalPagos": "1237.74",
                            "TotalRetencionesIVA": "125.34",
                            "TotalTrasladosBaseIVA16": "1175.07",
                            "TotalTrasladosImpuestoIVA16": "188.01"
                        }
                    },
                    "pago20:Pago": [
                        {
                            "@": {
                                "FechaPago": "2022-05-03T23:06:34",
                                "FormaDePagoP": "03",
                                "MonedaP": "MXN",
                                "Monto": "1237.74",
                                "TipoCambioP": "1"
                            },
                            "pago20:DoctoRelacionado": [
                                {
                                    "@": {
                                        "Serie": "A",
                                        "Folio": "01",
                                        "IdDocumento": "48928C7D-0A94-5F1F-89BE-722B5C6E3081",
                                        "NumParcialidad": "3",
                                        "MonedaDR": "MXN",
                                        "ImpSaldoAnt": "1237.74",
                                        "ImpPagado": "1237.74",
                                        "ImpSaldoInsoluto": "0.00",
                                        "ObjetoImpDR": "02",
                                        "EquivalenciaDR": "1"
                                    },
                                    "pago20:ImpuestosDR": {
                                        "pago20:RetencionesDR": {
                                            "pago20:RetencionDR": [
                                                {
                                                    "@": {
                                                        "BaseDR": "1175.07",
                                                        "ImporteDR": "125.34",
                                                        "ImpuestoDR": "002",
                                                        "TasaOCuotaDR": "0.106667",
                                                        "TipoFactorDR": "Tasa"
                                                    }
                                                }
                                            ]
                                        },
                                        "pago20:TrasladosDR": {
                                            "pago20:TrasladoDR": [
                                                {
                                                    "@": {
                                                        "BaseDR": "1175.07",
                                                        "ImporteDR": "188.01",
                                                        "ImpuestoDR": "002",
                                                        "TasaOCuotaDR": "0.160000",
                                                        "TipoFactorDR": "Tasa"
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                }
                            ],
                            "pago20:ImpuestosP": {
                                "pago20:RetencionesP": {
                                    "pago20:RetencionP": [
                                        {
                                            "@": {
                                                "ImporteP": "125.34",
                                                "ImpuestoP": "002"
                                            }
                                        }
                                    ]
                                },
                                "pago20:TrasladosP": {
                                    "pago20:TrasladoP": [
                                        {
                                            "@": {
                                                "BaseP": "1175.07",
                                                "ImporteP": "188.01",
                                                "ImpuestoP": "002",
                                                "TasaOCuotaP": "0.160000",
                                                "TipoFactorP": "Tasa"
                                            }
                                        }
                                    ]
                                }
                            }
                        }
                    ]
                }
            }
        },
        "xml":"...",
        "authToken": "...",
        "status": false,
        "sandbox": false
    }
]`
        }
    } as DocScripts,
    notarios: {
        requests: [{
            language: 'JSON',
            subtitle: 'Cuerpo del request',
            subsubtitle: '(application/json)',
            code: `
{
    "formaPago": "01",
    "metodoPago": "PUE",
    "lugarExpedicion": "06700",
    "receptor": {
        "nombre": "PUBLICO EN GENERAL",
        "rfc": "XAXX010101000",
        "usoCFDI": "G03"
    },
    "conceptos": [
        {
            "claveProdServ": "10101500",
            "claveUnidad": "KGM",
            "cantidad": 1,
            "descripcion": "PROYECTO ILUMINACION MASCAREÑO",
            "valorUnitario": 2000,
            "impuestos": [
                {
                    "type": "iva",
                    "retencion": false,
                    "tasa": 0.16
                }
            ]
        }
    ],
    // Extensión para complemento notarios
    "notariosPublicos": {
        "inmuebles":[{
            calle: "calle",
            tipoInmueble: "01", // Catalogo SAT inmuebles
            municipio: "Salina Cruz",
            estado: "20", // Catalogo SAT estados
            pais: "MEX", // Catalogo SAT paises
            codigoPostal: "70600",
            colonia: "Salina cruz centro",
            noExterior?: "295",
            noInterior?: "2A",
            referencia?: "Entre dos OXXO",
            localidad?: "Zona centro"
        }],
        "operacion": {
            fechaNotarial: "2018-09-07T17:54:26.150Z",
            numInstrumentoNotarial: "021545"
        },
        "notario": {
            curp: "123456789012345678", //18 length
            numNotaria: "17",
            estado: "20", // two decimals, 01 - 32
            adscripcion?: "Adcripcion del notario"
        },
        "enajenantes": [{
            nombre: "Jorge Antonio",
            rfc: "ANMJ561124JH6",
            porcentaje?: "55.00", // OBLIGATORY IF TWO ENAJENANTES (2 decimals, 0.00% - 100.00%)
            apellidoPaterno?: "Morales",
            apellidoMaterno?: "Villan",
            curp?: "123456789012345678"
        },{
            nombre: "Sasha",
            rfc: "MONSA561124JH6",
            porcentaje?: "45.00", // OBLIGATORY IF TWO ENAJENANTES (2 decimals, 0.00% - 100.00%)
            apellidoPaterno?: "Montenegro"
            curp?: "123456789012345678"
        }],
        "adquirientes": [{
            nombre: "Grupo Gutierrez",
            rfc: "GGRO920111K98",
            curp?: "123456789012345678"
        }]
    }
}
`
        }],
        response: {
            language: 'JSON',
            subtitle: 'Respuesta correcta',
            code: `
{
    "uuid": "3407BE43-651B-45B2-A721-D41295ED587B",
    "created": "2018-09-07T17:54:26.150Z",
    "json": {
        "@": {
            "xmlns:cfdi": "http://www.sat.gob.mx/cfd/3",
            "xmlns:xsi": "http://www.w3.org/2001/XMLSchema-instance",
            "xsi:schemaLocation": "http://www.sat.gob.mx/cfd/3 http://www.sat.gob.mx/sitio_internet/cfd/3/cfdv33.xsd",
            "Version": "3.3",
            "Serie": "A",
            "Folio": "01",
            "Fecha": "2018-09-07T12:54:25",
            "TipoDeComprobante": "I",
            "FormaPago": "01",
            "MetodoPago": "PUE",
            "LugarExpedicion": "06700",
            "SubTotal": "2000.00",
            "Total": "2320.00",
            "Moneda": "MXN",
            "Sello": "Eh49rUg0RiMsNmuiNwGay3oxWt9+Y16s+Ui9bq5+jzSicfkxPfUdCumYsAOndQRfUUK+cuWn1gCWBa/guFY1hwJYvFg/5X4gAZ...",
            "Certificado": "MIIF6zCCA9OgAwIBAgIUMjAwMDEwMDAwMDAzMDAwMDU2OTIwDQYJKoZIhvcNAQELBQAwggFmMSAwHgYDVQQDDBdBLkMu...",
            "NoCertificado": "20001000000300005692"
        },
        "cfdi:Emisor": {
            "@": {
                "Nombre": "Horacio Llanos",
                "Rfc": "ACO560518KW7",
                "RegimenFiscal": "601"
            }
        },
        "cfdi:Receptor": {
            "@": {
                "Nombre": "PUBLICO EN GENERAL",
                "Rfc": "XAXX010101000",
                "UsoCFDI": "G03"
            }
        },
        "cfdi:Conceptos": {
            "cfdi:Concepto": [
                {
                    "@": {
                        "ClaveProdServ": "10101500",
                        "ClaveUnidad": "KGM",
                        "Cantidad": "1",
                        "Descripcion": "VENTA DE TERRENO",
                        "ValorUnitario": "2000000.00",
                        "Importe": "2000000.00"
                    },
                    "cfdi:Impuestos": {
                        "cfdi:Traslados": {
                            "cfdi:Traslado": [
                                {
                                    "@": {
                                        "Base": "2000000.00",
                                        "Impuesto": "002",
                                        "TipoFactor": "Tasa",
                                        "TasaOCuota": "0.160000",
                                        "Importe": "320000.00"
                                    }
                                }
                            ]
                        }
                    }
                }
            ]
        },
        "cfdi:Impuestos": {
            "@": {
                "TotalImpuestosTrasladados": "320000.00"
            },
            "cfdi:Traslados": {
                "cfdi:Traslado": [
                    {
                        "@": {
                            "Impuesto": "002",
                            "TipoFactor": "Tasa",
                            "TasaOCuota": "0.160000",
                            "Importe": "320000.00"
                        }
                    }
                ]
            }
        },
        "cfdi:Complemento": {
            "notariospublicos:NotariosPublicos": {   
                "notariospublicos:DescInmuebles": {
                    "notariospublicos:DescInmueble": {
                        "@": {
                            "Calle": "...",
                            "TipoInmueble": "...",
                            "Municipio": "...",
                            "Estado": "...",
                            "Pais": "...",
                            "CodigoPostal": "...",
                            "Colonia": "...",
                            "NoExterior": "...",
                            "NoInterior": "...",
                            "Referencia": "...",
                            "Localidad": "..."
                        }
                    }[]
                };
                "notariospublicos:DatosOperacion": {
                    "@": {
                        "FechaInstNotarial": "...",
                        "IVA": "...",
                        "MontoOperacion": "...",
                        "NumInstrumentoNotarial": "...",
                        "Subtotal": "..."
                    }
                };
                "notariospublicos:DatosNotario": {
                    "@": {
                        "CURP": "...",
                        "NumNotaria": "...",
                        "EntidadFederativa": "...",
                        "Adscripcion": "..."
                    }
                };
                "notariospublicos:DatosEnajenante":{
                    "@":{
                        "CoproSocConyugalE": 'Si'|'No';
                    };
                    "notariospublicos:DatosUnEnajenante": {
                        "@":{
                            "Nombre":"...",
                            "RFC":"...",
                            "ApellidoMaterno":"...",
                            "ApellidoPaterno":"...",
                            "CURP":"..."
                        }
                    }
                    "notariospublicos:DatosEnajenantesCopSC": {
                        "notariospublicos:DatosEnajenanteCopSC": {
                            "@":{
                                "Nombre":"...",
                                "RFC":"...",
                                "Porcentaje": "...",// in a 50.00 as (50%) format
                                "ApellidoMaterno":"...",
                                "ApellidoPaterno":"...",
                                "CURP":"..."
                            }
                        }[]
                    }
                };
                "notariospublicos:DatosAdquiriente":{
                    "@":{
                        "CoproSocConyugalE": 'Si'|'No';
                    };
                    "notariospublicos:DatosUnAdquiriente": {
                        "@":{
                            "Nombre":"...",
                            "RFC":"...",
                            "ApellidoMaterno":"...",
                            "ApellidoPaterno":"...",
                            "CURP":"..."
                        }
                    }
                    "notariospublicos:DatosAdquirientesCopSC": {
                        "notariospublicos:DatosAdquirienteCopSC": {
                            "@":{
                                "Nombre":"...",
                                "RFC":"...",
                                "Porcentaje": "...",// in a 50.00 as (50%) format
                                "ApellidoMaterno":"...",
                                "ApellidoPaterno":"...",
                                "CURP":"..."
                            }
                        }[]
                    }
                }
            }
        }
    },
    "xml": ".....",
    "authToken": "...",
    "status": true,
    "sandbox": false
}`
        }
    } as DocScripts,
    transporte: {
        requests: [{
            language: 'JSON',
            subtitle: 'Cuerpo del request',
            subsubtitle: '(application/json)',
            code: `
{
    "lugarExpedicion": "06700",
    "serie": "TR",
    "folio": "01",
    "receptor": {
        "nombre": "PUBLICO EN GENERAL",
        "rfc": "XAXX010101000",
        "usoCFDI": "P01" // SIEMPRE P01
    },
    "conceptos": [
        {
            "cantidad": 1000,
            "descripcion": "Botellas vidrio 1 Litro Bostonianas"
        }
    ]
}
`
        }],
        response: {
            language: 'JSON',
            subtitle: 'Respuesta correcta',
            code: `
{
    "uuid": "3407BE43-651B-45B2-A721-D41295ED587B",
    "created": "2018-09-07T17:54:26.150Z",
    "json": {
        "@": {
            "xmlns:cfdi": "http://www.sat.gob.mx/cfd/3",
            "xmlns:xsi": "http://www.w3.org/2001/XMLSchema-instance",
            "xsi:schemaLocation": "http://www.sat.gob.mx/cfd/3 http://www.sat.gob.mx/sitio_internet/cfd/3/cfdv33.xsd",
            "Version": "3.3",
            "Serie": "TR",
            "Folio": "01",
            "Fecha": "2018-09-07T12:54:25",
            "TipoDeComprobante": "T",
            "LugarExpedicion": "06700",
            "SubTotal": "0.00",
            "Total": "0.00",
            "Moneda": "MXN",
            "Sello": "...",
            "Certificado": "...",
            "NoCertificado": "20001000000300005692"
        },
        "cfdi:Emisor": {
            "@": {
                "Nombre": "Horacio Llanos",
                "Rfc": "ACO560518KW7",
                "RegimenFiscal": "601"
            }
        },
        "cfdi:Receptor": {
            "@": {
                "Nombre": "PUBLICO EN GENERAL",
                "Rfc": "XAXX010101000",
                "UsoCFDI": "G03"
            }
        },
        "cfdi:Conceptos": {
            "cfdi:Concepto": [
                {
                    "@": {
                        "ClaveProdServ": "01010101",
                        "ClaveUnidad": "E48",
                        "Cantidad": "1000",
                        "Descripcion": "Botellas vidrio 1 Litro Bostonianas",
                        "ValorUnitario": "0",
                        "Importe": "0"
                    },
                }
            ]
        }
    },
    "xml": ".....",
    "authToken": "...",
    "status": true,
    "sandbox": false
}`
        }
    } as DocScripts,
}
